import { Box } from "@mui/material"
import React from "react"
import { ReportAcrissField, ReportCategoriesField } from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { useSignal } from "@preact/signals-react"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { AppIconChipToggle, AppFormGrid, AppFormSection } from "@components"

// The Common section restricted to the filters a One Way workbook honours: category and ACRISS
export default function ReportFormDrawerExportFiltersSection() {

	const { filterCategories, filterAcriss } = reportFormData.peek()

	const showSection = useSignal(!!(filterCategories?.length || filterAcriss?.length))

	return <AppFormSection
		icon="sliders"
		title="Filters for Excel export & Generation"
		hint="optional"
		data-tour-id="tour-export-filters"
		action={<AppIconChipToggle
			aria-label="Section"
			value={!!showSection.value}
			options={[
				{ value: false, label: 'Hide', icon: 'eye-slash' },
				{ value: true, label: 'Show', icon: 'eye' },
			]}
			onChange={value => showSection.value = value}
		/>}
	>
		{showSection.value && <AppFormGrid>
			<Box sx={{ gridColumn: 'span 6' }}>
				<ReportCategoriesField/>
			</Box>
			<Box sx={{ gridColumn: 'span 6' }}>
				<ReportAcrissField/>
			</Box>
		</AppFormGrid>}
	</AppFormSection>
}
